import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormLink from '../StepForm/StepFormLink';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form31(props: Props) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: replaceDefaultValues(
      {
        registrationNumber: '',
        infoConstructionYear: '',
      },
      props.defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Identificación de tu propiedad</h1>

      <FormElement
        name="registrationNumber"
        label="Número de la matrícula*"
        placeholder="Número de la matrícula"
        inputRef={register({ required: true })}
        error={errors.registrationNumber}
        elementType="text"
      />

      <FormElement
        name="infoConstructionYear"
        label="Año de construcción*"
        placeholder="Año de construcción"
        inputRef={register({ required: true, valueAsNumber: true })}
        error={errors.infoConstructionYear}
        elementType="number"
      />

      <FormElement
        label="carga el pdf del estudio de título o cómpralo a través del link y
        cárgalo"
        elementType="custom"
      >
        <input type="file" />
      </FormElement>

      <StepFormLink
        style={{ marginTop: 15 }}
        target="_external"
        href="external"
      >
        Link para comprar estudio
      </StepFormLink>

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
